import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import http from "../http-common";
import { checkHasOwnBusiness, checkIsEmployed } from "../services/Utils";

const useCandidature = (uuid) => {
  const [isLoading, setLoading] = useState(true);
  const [candidature, setCandidature] = useState({});

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (uuid != "redirect") {
        try {
          const response = await http.get(`/applications/by-uuid/${uuid}`);
          if (isMounted) {
            setCandidature(response.data);
            // Add a delay before setting loading to false
            setTimeout(() => {
              if (isMounted) setLoading(false);
            }, 100); // 2000 milliseconds = 2 seconds
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          // handle error, e.g., set an error state or show a notification
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [uuid]);

  return {
    isLoading,
    candidature,
  };
};

export default useCandidature;
